export const FETCH_PATYPELIST_BEGIN = 'FETCH_PATYPELIST_BEGIN';
export const FETCH_PATYPELIST_SUCCESS = 'FETCH_PATYPELIST_SUCCESS';
export const FETCH_PATYPELIST_ERROR = 'FETCH_PATYPELIST_ERROR';